import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, forwardRef, Provider, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { RevenueItemService } from '../shared/revenue-items/revenue-item.service';
import { RevenueItem } from '../shared/revenue-items/revenue-item.model';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../../shared/util/util.service';
import { AsyncState } from '../../shared/model/index';
import {
  NumberValueAccessor,
  CreateNumberValueAccessorProvider,
  CreateNumberValueValidationProvider,
} from '../../shared/widgets/value-accessors/number-value-accessor';

@Component({
  selector: 'wl-revenue-item-selector',
  templateUrl: 'revenue-item-selector.component.html',
  styleUrls: ['revenue-item-selector.component.css'],
  providers: [
    RevenueItemService,
    CreateNumberValueAccessorProvider(RevenueItemSelectorComponent),
    CreateNumberValueValidationProvider(RevenueItemSelectorComponent),
  ],
  standalone: false
})
export class RevenueItemSelectorComponent extends NumberValueAccessor implements OnInit {
  @Input() includeNoneValue: boolean = true;
  @Input() noneValueDisplay: string = '';
  @Input() paymentTypeId: number = 0;
  @Input() accountingPackageId: number = 0;
  @Input() taxableItemsOnly: boolean = false;
  @Input() taxItemsOnly: boolean = false;

  //for validation to know if 0 an be allowed
  @Input() required: any;

  @Output() onRevenueItemChanged = new EventEmitter<RevenueItem>();

  public _revenueItemService: RevenueItemService;
  public _translateService: TranslateService;
  public _utilService: UtilService;
  public _noneText: string;

  public loading: AsyncState = new AsyncState();
  public revenueItems: Array<RevenueItem>;

  public constructor(revenueItemService: RevenueItemService, translateService: TranslateService, utilService: UtilService) {
    super();
    this._revenueItemService = revenueItemService;
    this._translateService = translateService;
    this._utilService = utilService;
    this._noneText = '';

    this.revenueItems = new Array<RevenueItem>();
  }

  //this overrides the base class function to set
  //what it means for this this control to be valid
  isValid = (): boolean => {
    if (this._utilService.isNotNullOrUndefined(this.required)) {
      if (this.value > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  ngOnInit() {
    this.loadRevenueItems();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.loadRevenueItems();
  }
  modelChange(data: string) {
    //the data comes thru as a string convert to int
    this.value = parseInt(data);

    this.emitOutputObject();
  }

  loadRevenueItems = (): void => {
    this.loading.busy = true;
    this.loading.message = '';
    this.loading.success = false;

    if (this.paymentTypeId > 0) {
      this._revenueItemService
        .getRevenueItemsForPaymentType(this.paymentTypeId)
        .then((data: Array<RevenueItem>) => {
          this.loading.busy = false;
          this.loading.success = true;
          this.revenueItemDataCallBack(data);
        })
        .catch(error => {
          this.loading.busy = false;
          this.loading.message = this._utilService.extractErrorMessage(error);
          this.loading.success = false;
        });
    } else if (this.accountingPackageId > 0) {
      this._revenueItemService
        .getRevenueItemsForAccountingPackage(this.accountingPackageId)
        .then((data: Array<RevenueItem>) => {
          this.loading.busy = false;
          this.loading.success = true;
          this.revenueItemDataCallBack(data);
        })
        .catch(error => {
          this.loading.busy = false;
          this.loading.message = this._utilService.extractErrorMessage(error);
          this.loading.success = false;
        });
    } else {
      this._revenueItemService
        .getRevenueItems()
        .then((data: Array<RevenueItem>) => {
          this.loading.busy = false;
          this.loading.success = true;
          this.revenueItemDataCallBack(data);
        })
        .catch(error => {
          this.loading.busy = false;
          this.loading.message = this._utilService.extractErrorMessage(error);
          this.loading.success = false;
        });
    }
  };
  revenueItemDataCallBack = (data: Array<RevenueItem>): void => {
    this.revenueItems = data;
    if (this.taxableItemsOnly == true) {
      let filter: Array<RevenueItem> = this.revenueItems.filter(item => {
        return item.Taxable == true;
      });

      this.revenueItems = filter;
    }
    if (this.taxItemsOnly == true) {
      let filter: Array<RevenueItem> = this.revenueItems.filter(item => {
        return item.TaxType == true;
      });

      this.revenueItems = filter;
    }

    this.revenueItemAddNone(this.revenueItems).then((data: Array<RevenueItem>): void => {
      if (this.paymentTypeId > 0) {
        let filter: Array<RevenueItem> = this.revenueItems.filter(item => {
          return item.ItemNum == this.value;
        });
        if (filter.length == 0) {
          //the currently selected ItemNum is not in the list of avail revenue items
          this.value = 0;
        }
      }

      this.emitOutputObject();
    });
  };

  revenueItemAddNone = (data: Array<RevenueItem>): Promise<Array<RevenueItem>> => {
    return Promise.resolve(this.revenueItems);
  };

  emitOutputObject = (): void => {
    let filter: Array<RevenueItem> = this.revenueItems.filter(item => {
      return item.ItemNum == this.value;
    });
    if (filter.length > 0) {
      //emit the selected rev item full object
      this.onRevenueItemChanged.emit(filter[0]);
    }
  };
}
